import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import { format } from 'app/shared/utils/string.util';
import { TabularTypeDataset } from './tabular-type.dataset';
import { IModel } from '../base/annotation';
import { SharePointOnlineListLinkedService } from 'app/model/linkedservice/sharepoint-online-list.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.sharePointOnlineList.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.SharePointOnlineListResource_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.SharePointOnlineListResource_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SharePointOnlineListLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SharePointOnlineListResourceDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
